app.service('goBack', function (console, localStorage, loading) {
	function go() {
		console.log('POWRÓT DO POPRZEDNIEJ STRONY');
		var url = '/';
		if (!localStorage.empty('refpage')) {
			url = check(localStorage.getItem('refpage'));
		}
		loading.redirect({
			href: url,
			soft: false
		});
	}

	function check(tmpUrl) {
		tmpUrl = "" + tmpUrl;
		if (tmpUrl.indexOf("<") > -1) {
			tmpUrl = tmpUrl.substr(0, tmpUrl.indexOf("<"));
		}
		return tmpUrl;
	}

	/* 
	* Poniższy skrypt ustawia informację o pierwszym wpisie w historii i jeśli nie ma historii przeglądania w ramach "starego frontu", to wraca aplikacji mobilnej.
	*/
	const KEY = '__overlayFirst';
	const stamped = history.state?.[KEY];
	const isFirst = typeof stamped === 'boolean' ? stamped : history.length === 1;

	history.replaceState({ ...(history.state ?? {}), [KEY]: isFirst }, '');

	function overlayBackOrClose() {
		if (history.state?.[KEY] === true) {
		window.mobileApp.close(); // ostemplowany pierwszy wpis - nie ma dokąd wracać
		} else {
		history.back(); // ostemplowany dalszy wpis albo pushState strony - back jest legalny
		}
	};

	return {
		go, 
		overlayBackOrClose
	};
});
